// extracted by mini-css-extract-plugin
export default {"base":"IconOverlap_base__O9H8h","overlap-icon-wrapper":"IconOverlap_overlap-icon-wrapper__7At7h"};